<template>
    <v-layout wrap class="px-0 mx-0" style="margin-top: -11px;">
        <span
            style="font-size: 11px; margin-left: 8px;color: black;background-color: snow !important; z-index: 5; width: auto;margin-bottom: -11px">{{label}}</span>
        <v-layout class="px-1" row style="border-style: solid;border-width: thin;border-radius: 5px;"
                  wrap>
            <v-flex xs4 class="pa-1">
                <v-autocomplete
                    :items="days_array"
                    class="custom"
                    flat
                    solo
                    hide-details
                    label="Day *"
                    style="padding: 0;"
                    v-model="dob.day"
                />
            </v-flex>

            <v-flex style="padding-right: 8px;" xs4 class="pa-1">
                <v-autocomplete
                    :items="months"
                    class="custom"
                    flat
                    solo
                    hide-details
                    item-text="value"
                    item-value="number"
                    label="Month *"
                    style="padding: 0;"
                    v-model="dob.month"
                />
            </v-flex>
            <v-flex style="padding-right: 8px;" xs4 class="pa-1">
                <v-autocomplete
                    :items="years"
                    class="custom"
                    flat
                    solo
                    hide-details
                    label="Year *"
                    style="padding: 0;"
                    type="text"
                    v-model="dob.year"
                />
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import {validationMixin} from "../mixins/validationMixin";
    //
    export default {
        name: "DatePickerNepali",
        props: ['label', 'value', 'maxYear', 'minYear', 'watchValue'],
        data() {
            return {
                dob: {
                    year: null,
                    month: null,
                    day: null
                },
                years: [],
                days_array: [],
                months: [
                    {
                        number: '01',
                        value: 'Baishak'
                    },
                    {
                        number: '02',
                        value: 'Jestha'
                    },
                    {
                        number: '03',
                        value: 'Asar'
                    },
                    {
                        number: '04',
                        value: 'Shrawan'
                    },
                    {
                        number: '05',
                        value: 'Bhadra'
                    },
                    {
                        number: '06',
                        value: 'Asoj'
                    },
                    {
                        number: '07',
                        value: 'Kartik'
                    },
                    {
                        number: '08',
                        value: 'Mangshir'
                    },
                    {
                        number: '09',
                        value: 'Poush'
                    },
                    {
                        number: '10',
                        value: 'Magh'
                    },
                    {
                        number: '11',
                        value: 'Falgun'
                    },
                    {
                        number: '12',
                        value: 'Chaitra'
                    }

                ]
            }
        },
        mixins: [validationMixin],
        computed: {
            year_value() {
                return this.dob.year + '-' + this.dob.month + '-' + this.dob.day;
            }
        },
        watch: {
            year_value() {
                this.$emit('input', this.year_value)
            },
            value() {
                if (this.value && this.watchValue) {
                    this.dob.year = parseInt(this.value.substr(0, 4));
                    this.dob.month = this.value.substr(5, 2);
                    this.dob.day = this.value.substr(8, 2);
                }
            }
        },
        mounted() {
            let currentYear = new Date().toISOString().substr(0, 4);
            currentYear = parseInt(currentYear);
            let years_array = [];
            let maximumYear = currentYear + 12;
            let minimumYear = 2015;
            if (this.maxYear) {
                maximumYear = this.maxYear;
            }
            if (this.minYear) {
                minimumYear = this.minYear;
            }


            for (let i = minimumYear; i <= maximumYear; i++) {
                years_array.push(i);
            }
            years_array = years_array.reverse();
            this.years = years_array;
            const days_array = [];

            for (let i = 1; i <= 31; i++) {
                let value = i < 10 ? ('0' + i) : i.toString();
                days_array.push(value)
            }
            this.days_array = days_array;
            if (this.value) {
                this.dob.year = parseInt(this.value.substr(0, 4));
                this.dob.month = this.value.substr(5, 2);
                this.dob.day = this.value.substr(8, 2);
            }
        }
    }
</script>

<style>
    .custom.v-text-field > .v-input__control > .v-input__slot:before {
        border-style: none;
        padding-top: 0;
        padding-bottom: -40px;
    }

    .custom.v-text-field > .v-input__control > .v-input__slot:after {
        border-style: none;
        padding-top: 0;
        padding-bottom: -40px;
    }
</style>

